var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isDocumentsTypeBusy)?_c('v-progress-linear',{attrs:{"indeterminate":"","rounded":"","color":"primary"}}):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }